// extracted by mini-css-extract-plugin
export default {"overlay":"PlayButtonOverlay_overlay__nOQ4V","playButton":"PlayButtonOverlay_playButton__5n7IU"};